export default {
  aboutTabLegalName: {
    id: 'seller_page_about_tab_legal_name',
    defaultMessage: 'Legal name',
  },
  aboutTabVatNumber: {
    id: 'seller_page_about_tab_vat_number',
    defaultMessage: 'VAT number',
  },
  aboutTabSiretNumber: {
    id: 'seller_page_about_tab_siren_number',
    defaultMessage: 'SIREN number',
  },
  aboutTabAddress: {
    id: 'seller_page_about_tab_legal_address',
    defaultMessage: 'Legal address',
  },
  aboutTabCountryOfOrigin: {
    id: 'seller_page_about_tab_country',
    defaultMessage: "Seller's country of origin",
  },
  konbiniCompanyName: {
    id: 'landing_seller_konbini_company_name',
    defaultMessage: 'Company Name:',
  },
  konbiniStoreName: {
    id: 'landing_seller_konbini_store_name',
    defaultMessage: 'Store Name:',
  },
  landingSellerDescriptionAddress: {
    id: 'landing_seller_description_address',
    defaultMessage: 'Address:',
  },
  konbiniEmail: {
    id: 'landing_seller_konbini_email',
    defaultMessage: 'Email address:',
  },
  konbiniPhoneNumber: {
    id: 'landing_seller_konbini_phone',
    defaultMessage: 'Phone number:',
  },
  konbiniSecondHandDealerNumber: {
    id: 'landing_seller_konbini_secondhand_dealer_number',
    defaultMessage: 'Second hand dealer number:',
  },
  konbiniSecondhandDealerNumberIssuingPrefecture: {
    id: 'landing_seller_konbini_secondhand_dealer_number_issuing_prefecture',
    defaultMessage: 'Secondhand number issuing prefecture:',
  },
  konbiniStoreOperationManager: {
    id: 'landing_seller_konbini_store_operation_manager',
    defaultMessage: 'Business operation manager:',
  },
  konbiniStoreSecurityOfficer: {
    id: 'landing_seller_konbini_store_security_officer',
    defaultMessage: 'Business security officer:',
  },
  konbiniPhoneExplanationNotice: {
    id: 'landing_seller_konbini_phone_explanation_notice',
    defaultMessage: 'Please do not call the seller directly.',
  },
  konbiniBlockTitle: {
    id: 'landing_seller_konbini_block_title',
    defaultMessage:
      'For inquiries, please contact Back Market customer support.',
  },
  konbiniBlockContent: {
    id: 'landing_seller_konbini_block_content',
    defaultMessage:
      'Please refrain from contacting sellers directly as it will be difficult for the support team to provide you with appropriate guidance.',
  },
  aboutTabTradeRegisterNumber: {
    id: 'seller_page_about_tab_trade_register_number',
    defaultMessage: 'Trade register number',
  },
  aboutTabTradeRegisterInfoLabel: {
    id: 'seller_page_about_tab_trade_register_info_label',
    defaultMessage: 'More information about the trade register number',
  },
  aboutTabTradeRegisterInfoDescription: {
    id: 'seller_page_about_tab_trade_register_info_description',
    defaultMessage:
      'This number identifies the seller as a registered business in their country. Its name varies by country:',
  },
  aboutTabTradeRegisterInfoCountry: {
    id: 'seller_page_about_tab_trade_register_info_country',
    defaultMessage: 'Country',
  },
  aboutTabTradeRegisterInfoRegisterNumber: {
    id: 'seller_page_about_tab_trade_register_info_register_number',
    defaultMessage: 'Trade register no',
  },
  aboutTabTradeRegisterInfoFrance: {
    id: 'seller_page_about_tab_trade_register_info_france',
    defaultMessage: 'France',
  },
  aboutTabTradeRegisterInfoSiren: {
    id: 'seller_page_about_tab_trade_register_info_siren',
    defaultMessage: 'Nº SIREN',
  },
  aboutTabTradeRegisterInfoUk: {
    id: 'seller_page_about_tab_trade_register_info_uk',
    defaultMessage: 'United Kingdom',
  },
  aboutTabTradeRegisterInfoSellerRegistrationNo: {
    id: 'seller_page_about_tab_trade_register_info_seller_registration_no',
    defaultMessage: 'Seller registration no.',
  },
  aboutTabTradeRegisterInfoGermany: {
    id: 'seller_page_about_tab_trade_register_info_germany',
    defaultMessage: 'Germany',
  },
  aboutTabTradeRegisterInfoGermanyNumber: {
    id: 'seller_page_about_tab_trade_register_info_germany_number',
    defaultMessage: 'Handelsregisternummer',
  },
  aboutTabTradeRegisterInfoNetherlands: {
    id: 'seller_page_about_tab_trade_register_info_netherlands',
    defaultMessage: 'Netherlands',
  },
  aboutTabTradeRegisterInfoNetherlandsNumber: {
    id: 'seller_page_about_tab_trade_register_info_netherlands_number',
    defaultMessage: 'KvK-nummer',
  },
  aboutTabTradeRegisterInfoAustria: {
    id: 'seller_page_about_tab_trade_register_info_austria',
    defaultMessage: 'Austria',
  },
  aboutTabTradeRegisterInfoAustriaNumber: {
    id: 'seller_page_about_tab_trade_register_info_austria_number',
    defaultMessage: 'Handelsregisternummer',
  },
  aboutTabTradeRegisterInfoSpain: {
    id: 'seller_page_about_tab_trade_register_info_spain',
    defaultMessage: 'Spain',
  },
  aboutTabTradeRegisterInfoSpainNumber: {
    id: 'seller_page_about_tab_trade_register_info_spain_number',
    defaultMessage: 'Extracto de Registro Mercantil',
  },
  aboutTabTradeRegisterInfoItaly: {
    id: 'seller_page_about_tab_trade_register_info_italy',
    defaultMessage: 'Italy',
  },
  aboutTabTradeRegisterInfoItalyNumber: {
    id: 'seller_page_about_tab_trade_register_info_italy_number',
    defaultMessage: 'C.F. e P.IVA',
  },
  aboutTabTradeRegisterInfoBelgium: {
    id: 'seller_page_about_tab_trade_register_info_belgium',
    defaultMessage: 'Belgium',
  },
  aboutTabTradeRegisterInfoBelgiumNumber: {
    id: 'seller_page_about_tab_trade_register_info_belgium_number',
    defaultMessage: 'N° de KBO/BCE',
  },
  aboutTabTradeRegisterInfoIreland: {
    id: 'seller_page_about_tab_trade_register_info_ireland',
    defaultMessage: 'Ireland',
  },
  aboutTabTradeRegisterInfoIrelandNumber: {
    id: 'seller_page_about_tab_trade_register_info_ireland_number',
    defaultMessage: 'Trade register number',
  },
  aboutTabTradeRegisterInfoPortugal: {
    id: 'seller_page_about_tab_trade_register_info_portugal',
    defaultMessage: 'Portugal',
  },
  aboutTabTradeRegisterInfoPortugalNumber: {
    id: 'seller_page_about_tab_trade_register_info_portugal_number',
    defaultMessage: 'Número de registo comercial',
  },
  aboutTabTradeRegisterInfoFinland: {
    id: 'seller_page_about_tab_trade_register_info_finland',
    defaultMessage: 'Finland',
  },
  aboutTabTradeRegisterInfoFinlandNumber: {
    id: 'seller_page_about_tab_trade_register_info_finland_number',
    defaultMessage: 'Yritystunnus',
  },
  aboutTabTradeRegisterInfoSweden: {
    id: 'seller_page_about_tab_trade_register_info_sweden',
    defaultMessage: 'Sweden',
  },
  aboutTabTradeRegisterInfoSwedenNumber: {
    id: 'seller_page_about_tab_trade_register_info_sweden_number',
    defaultMessage: 'Organisationsnummer',
  },
  aboutTabTradeRegisterInfoGreece: {
    id: 'seller_page_about_tab_trade_register_info_greece',
    defaultMessage: 'Greece',
  },
  aboutTabTradeRegisterInfoGreeceNumber: {
    id: 'seller_page_about_tab_trade_register_info_greece_number',
    defaultMessage: 'Αριθμός μητρώου επιχείρησης',
  },
  aboutTabTradeRegisterInfoSlovakia: {
    id: 'seller_page_about_tab_trade_register_info_slovakia',
    defaultMessage: 'Slovakia',
  },
  aboutTabTradeRegisterInfoSlovakiaNumber: {
    id: 'seller_page_about_tab_trade_register_info_slovakia_number',
    defaultMessage: 'Identifikačné číslo',
  },
  aboutTabTradeRegisterInfoExtraText: {
    id: 'seller_page_about_tab_trade_register_info_extra_text',
    defaultMessage: `For any country not listed above, "Trade registeratrion number" is the equivalent business registration number in the seller's country of origin.`,
  },
}
